export default [
  // {
  //   path: '/academy/learning-fields',
  //   name: 'learning-fields.index',
  //   component: () => import('@/pages/Academy/LearningFields/Index'),
  //   meta: {
  //     perimeter: 'AuthPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/academy/learning-fields/create',
  //   name: 'learning-fields.create',
  //   component: () => import('@/pages/Academy/LearningFields/Create'),
  //   meta: {
  //     perimeter: 'AdminPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/academy/learning-fields/:id/edit',
  //   name: 'learning-fields.edit',
  //   component: () => import('@/pages/Academy/LearningFields/Edit'),
  //   meta: {
  //     perimeter: 'AdminPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/academy/courses/create',
  //   name: 'courses.create',
  //   component: () => import('@/pages/Academy/Courses/Create'),
  //   meta: {
  //     perimeter: 'InternalPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/academy/courses/:id/edit',
  //   name: 'courses.edit',
  //   component: () => import('@/pages/Academy/Courses/Edit'),
  //   meta: {
  //     perimeter: 'InternalPerimeter',
  //   },
  // },

  {
    path: '/academy',
    name: 'academy.index',
    component: () => import('@/pages/Academy/Landing/Index'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/academy/publications/list/:type',
    name: 'publications.index',
    component: () => import('@/pages/Academy/Publications/Index'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/academy/publications/create/:id?',
    name: 'publications.create',
    component: () => import('@/pages/Academy/Publications/Create'),
    meta: {
      perimeter: 'InternalPerimeter',
    },
  },

  {
    path: '/academy/publications/:id',
    name: 'publications.view',
    component: () => import('@/pages/Academy/Publications/View'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/academy/publications/:id/edit',
    name: 'publications.edit',
    component: () => import('@/pages/Academy/Publications/Edit'),
    meta: {
      perimeter: 'InternalPerimeter',
    },
  },

  // {
  //   path: '/academy/publications/:id/questions/create',
  //   name: 'questions-id.create',
  //   component: () => import('@/pages/Academy/Questions/Create'),
  //   meta: {
  //     perimeter: 'InternalPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/academy/publications/:id/questions',
  //   name: 'questions.publication',
  //   component: () => import('@/pages/Academy/Questions/IndexPublication'),
  //   meta: {
  //     perimeter: 'InternalPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/academy/questions/create',
  //   name: 'questions.create',
  //   component: () => import('@/pages/Academy/Questions/Create'),
  //   meta: {
  //     perimeter: 'InternalPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/academy/questions/:id/edit',
  //   name: 'questions.edit',
  //   component: () => import('@/pages/Academy/Questions/Edit'),
  //   meta: {
  //     perimeter: 'InternalPerimeter',
  //   },
  // },

  // {
  //   path: '/academy/questions',
  //   name: 'questions.index',
  //   component: () => import('@/pages/Academy/Questions/Index'),
  //   meta: {
  //     perimeter: 'AuthPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/academy/questions/answer/:id?',
  //   name: 'questions.view',
  //   component: () => import('@/pages/Academy/Questions/View'),
  //   meta: {
  //     perimeter: 'AuthPerimeter',
  //   },
  // },

  // {
  //   path: '/academy/dashboard',
  //   name: 'dashboard.index',
  //   component: () => import('@/pages/Academy/Dues/Index'),
  //   meta: {
  //     perimeter: 'AuthPerimeter',
  //   },
  // },

];



// WEBPACK FOOTER //
// ./src/routes/academy.js